import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import session from './session';
import floodlight from './floodlight';
import newDocs from './newDocumentStore';
import viewstate from './viewstate';
import neuroDocuments from './neuroDocuments';
import settings from './settings';

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    router,
    form,
    session,
    floodlight,
    newDocs,
    viewstate,
    neuroDocuments,
    settings,
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
